import { Icon } from "@eventr/common-storybook";
import { useParams } from "react-router-dom";
import { routes } from "routing";
import { useEditSectionContext } from "../../feat/editItinerary/editSectionProvider";
import { useGlobalRouter } from "../../feat/globalRouter/useGlobalRouter";

interface IEditButton {
  data: any;
  renderOptions: any;
}

export const EditArrowIcon = ({ data, renderOptions }: IEditButton) => {
  const { section } = useEditSectionContext();
  const { pushPath } = useGlobalRouter();

  const { itemId: idItem } = useParams<{
    itemId: string;
  }>();
  const path = () => {
    if (renderOptions.pageId) {
      return routes.edit.sectionItemPageItem.build({
        sectionId: section!.id,
        itemId: idItem!,
        pageId: renderOptions.pageId,
        subItemId: data._id,
      });
    } else {
      return routes.edit.sectionItem.build({ sectionId: section!.id, itemId: data._id });
    }
  };
  return (
    // <MainButton
    //     icon="Edit"
    //     text={f(m.General.Edit)}
    //     size="small"
    //     onClick={() => {
    //         hist.push(path())
    //     }}
    // />
    <Icon
      name="Chevron_Right"
      onClick={() => {
        pushPath(path());
      }}
    />
  );
};
